export const SHOWTIME_DATE_FORMAT = 'YYYY-MM-DD';
export const SHOWTIME_UI_DATE_FORMAT = 'ddd D MMM';
export const SHOWTIME_TIME_FORMAT_12_HOURS = 'h:mmA';
export const SHOWTIME_TIME_FORMAT_24_HOURS = 'HHmm';
export const CINEMA_LIST_SIZE_FOR_SMALL_SCREEN = 6;
export const CINEMA_LIST_SIZE_FOR_LARGE_SCREEN = 12;
